import React from 'react';
import { View } from '@react-pdf/renderer';
import PropTypes from 'prop-types';
import { Heading } from '../../../../components/Heading';
import { DocumentationUploadSectionDescription } from './components/DocumentationUploadSectionDescription';
import { DocumentationNotes } from './components/DocumentationNotes';

export function ProjectDocumentationUploadSection({ data }) {
  return (
    <View>
      <Heading name="Project Documents" />
      <DocumentationUploadSectionDescription />
      <DocumentationNotes data={data} />
    </View>
  );
}

ProjectDocumentationUploadSection.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ProjectDocumentationUploadSection;
